import { getAvailableTag } from '../../../data/repositories/businessRepository.js';

export const checkTagAvailability = (tag) => getAvailableTag(tag);
